const prod = { API_URL: process.env.REACT_APP_PROD_URL + '/api/v1' }

const dev = { API_URL: process.env.REACT_APP_DEV_URL + '/api/v1' }

export const mainUrl = process.env.NODE_ENV === 'development' ? dev : prod
